<template>
  <nav
    class="navbar custom_nav navbar-expand-lg fixed-top sticky active justify-content-between bg-white"
  >
    <div class="container">
      <a class="logo navbar-brand" href="javascript:void(0)">
        <img :src="dukaURL+'assets/images/logo.png'" alt class="img-fluid logo-light" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i class="mdi mdi-menu"></i>
      </button>

      <div class="collapse navbar-collapse active" id="navbarCollapse">
        <!-- menu -->
        <ul id="menu-home-menu" class="nav navbar-nav main_menu">
          <li class="nav-item active">
            <a class="nav-link" href="javascript:void(0)">Features</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)">Pricing</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)">Reviews</a>
          </li>
        </ul>

        <!--/Menu -->
      </div>
      <div class="float-right">
        <ul class="list-unstyled list-inline mb-0">
          <li class="list-inline-item">
            <a href="javascript:void(0);" class="btn btn-gradient btn-sm mr-2">Buy Pro plan</a>
          </li>
          <li class="list-inline-item">
            <router-link :to="{ name:'login' }" class="nav-link">Login</router-link>
          </li>
          <li class="list-inline-item">
            <router-link :to="{ name:'signup' }">Sign up</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: "Header",
  data: () => ({}),
  methods: {}
};
</script>
